import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain="bean7.us.auth0.com"
      clientId="a80QHeDN2sHwSm6CYOAMrrG8ZEapf73f"
      redirectUri={window.location.origin}
      scope="create:todo read:todo update:todo delete:todo"
      audience="https://beans-auth0.jse.li/"
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
